import { inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import type { InventoryUnitEventType, InventoryUnitStatus } from './models/inventory.model';
import { BusinessSettingsStore } from '../../core/settings';

const EM_DASH = '—';
let inventoryDatePipe: DatePipe | null = null;
let timeZone = 'Europe/Madrid';

const getInventoryDatePipe = (): DatePipe => {
  if (!inventoryDatePipe) {
    const businessSettingsStore = new BusinessSettingsStore();
    timeZone = businessSettingsStore.timeZone();
    inventoryDatePipe = new DatePipe('en-GB', timeZone);
  }
  return inventoryDatePipe;
};

export const formatInventoryUnitStatusLabel = (status: InventoryUnitStatus): string => {
  switch (status) {
    case 'AVAILABLE':
      return 'Disponible';
    case 'IN_REPAIR':
      return 'En reparación';
    case 'MISSING':
      return 'Faltante';
    case 'SOLD':
      return 'Vendido';
  }

  return status;
};

export const formatInventoryEventTypeLabel = (type: InventoryUnitEventType): string => {
  switch (type) {
    case 'UNIT_REGISTERED':
      return 'Unidad registrada';
    case 'UNIT_REENTERED':
      return 'Unidad reingresada';
    case 'STATUS_CHANGED':
      return 'Estado actualizado';
    case 'STORE_REASSIGNED':
      return 'Local reasignado';
    case 'REPAIR_STARTED':
      return 'Reparación iniciada';
    case 'REPAIR_FINISHED':
      return 'Reparación finalizada';
    case 'UNIT_MARKED_MISSING':
      return 'Unidad marcada como faltante';
    case 'UNIT_RECOVERED':
      return 'Unidad recuperada';
    case 'UNIT_SOLD':
      return 'Unidad vendida';
    case 'PRICE_CHANGED':
      return 'Precio actualizado';
    case 'COST_PRICE_CHANGED':
      return 'Costo actualizado';
    case 'UNIT_IDENTITY_CORRECTED':
      return 'Identidad corregida';
    case 'UNIT_VARIANT_CORRECTED':
      return 'Variante corregida';
    case 'TRANSFER_OUTBOUND':
      return 'Transferencia despachada';
    case 'TRANSFER_RECEIVED_PARTIAL':
      return 'Transferencia recibida parcial';
    case 'TRANSFER_RECEIVED_FINAL':
      return 'Transferencia recibida completa';
    case 'TRANSFER_SHORTAGE_CLOSED':
      return 'Faltantes de transferencia cerrados';
    case 'TRANSFER_CANCELLED':
      return 'Transferencia cancelada';
  }

  return type;
};

export const formatInventoryDate = (value: string | null | undefined): string => {
  return getInventoryDatePipe().transform(value, 'dd/MM/yyyy', timeZone) ?? EM_DASH;
};

export const formatInventoryDateTime = (value: string | null | undefined): string => {
  return getInventoryDatePipe().transform(value, 'dd/MM/yyyy, HH:mm', timeZone) ?? EM_DASH;
};
